export default __webpack_public_path__ + "static/media/content4_3.f1b2e38d.gif";